import { useMemo } from 'react';
import { useTheme } from '../contexts/ThemeContext';

function getColorForName(name, theme) {
    if (!name) return theme.textSecondary;
    const palette = [theme.accent, theme.secondary, theme.success, theme.warning, theme.danger, theme.tertiary];
    const hash = name.split('').reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
    return palette[hash % palette.length];
}

function GameLog({ title = 'Game Log', entries = [], maxHeight = 160 }) {
    const { theme } = useTheme();
    const visibleEntries = useMemo(() => entries.slice(-14), [entries]);

    return (
        <div
            style={{
                backgroundColor: theme.bgDark,
                border: `2px solid ${theme.bgLight}`,
                borderRadius: '10px',
                padding: '10px',
                width: '100%',
                maxWidth: '520px',
                margin: '10px auto 0',
                color: theme.textPrimary
            }}
        >
            <div
                style={{
                    fontSize: '0.85rem',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    color: theme.textSecondary,
                    marginBottom: '8px'
                }}
            >
                {title}
            </div>
            <div
                style={{
                    maxHeight,
                    overflowY: 'auto',
                    display: 'grid',
                    gap: '6px',
                    paddingRight: '4px'
                }}
            >
                {visibleEntries.length === 0 ? (
                    <div style={{ fontSize: '0.9rem', color: theme.textDisabled }}>
                        No events yet.
                    </div>
                ) : (
                    visibleEntries.map((entry) => (
                        <div key={entry.id} style={{ fontSize: '0.88rem', lineHeight: 1.25 }}>
                            {entry.actor ? (
                                <span style={{ color: getColorForName(entry.actor, theme), fontWeight: 'bold' }}>
                                    {entry.actor}:{' '}
                                </span>
                            ) : null}
                            <span style={{ color: theme.textPrimary }}>{entry.text}</span>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default GameLog;
